<template>
  <div v-if="!model.$disabled">
    <label v-if="showLabel" class="label" :for="sid">
      <template v-if="label">{{ typeof label == 'string' ? label : getTitle }}</template>

      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </label>

    <select
      v-if="renderReady"
      :id="sid"
      ref="input"
      class="form-control"
      :aria-invalid="errorVisible"
      :aria-describedby="errorVisible ? errId : undefined"
      :class="borderValidationClass"
      :disabled="disabled"
      :name="model.$form.testPath ? model.$path : undefined"
      :placeholder="placeholder"
      :title="titleAttribute || model.$schema.title"
      :value="svalue"
      @input="onInput"
      @change="onInput"
      @focus="onFocus($event)"
      @blur="onBlur($event)"
    >
      <option v-if="placeholder" disabled="disabled" value :selected="svalue === null || svalue === undefined">
        {{ placeholder }}
      </option>

      <template v-for="(value, index) in values">
        <option
          v-if="!value.children"
          :key="index"
          :value="value.value"
          :disabled="value.disabled"
          :selected="svalue == value.value"
        >
          {{ value.text }}
        </option>

        <optgroup v-else :key="index" :label="value.text">
          <option
            v-for="(child, index2) in value.children"
            :key="index2"
            :value="child.value"
            :disabled="child.disabled"
            :selected="svalue == value.value"
          >
            {{ child.text }}
          </option>
        </optgroup>
      </template>
    </select>

    <w-error :model="model" :err-id="errId" @focus="$refs.input.focus()" />
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import { errorMixin } from '../mixins/errorMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'WSelect',
  components: { WError, WTooltip },
  mixins: [modelMixin, errorMixin('sel')],
  props: {
    values: Array,
    label: {
      type: [String, Boolean],
      default: true
    },
    placeholder: String,
    setTitleAsPlaceholder: {
      type: Boolean,
      default: false
    },
    titleAttribute: String
  },
  computed: {
    showLabel() {
      if (this.showTooltip) {
        return true;
      }
      if (!this.label) {
        return false;
      }
      if (typeof this.label === 'boolean') {
        return !!this.getTitle;
      }
      return true;
    }
  },
  mounted() {
    if (this.setTitleAsPlaceholder) {
      this.placeholder = this.getTitle;
      this.label = false;
    }
  },
  methods: {
    textValue() {
      const ff = this.svalue;
      for (let i = 0; i < this.values.length; i++) {
        const vv = this.values[i];
        if (vv.children) {
          for (let j = 0; j < vv.children.length; j++) {
            if (vv.children[j].value === ff) {
              return vv.children[j].text;
            }
          }
        } else {
          if (vv.value === ff) {
            return vv.text;
          }
        }
      }
      return this.placeholder || '';
    }
  }
};
</script>
